/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions(value) {
    if (!('SteamId' in value) || value['SteamId'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptionsFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'SteamId': json['SteamId'],
    };
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptionsToJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptionsToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'SteamId': value['SteamId'],
    };
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions.js.map